import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from 'components/shared/Modal/Modal';
import classnames from 'classnames';
import './Toggle.css';
import { IconLoader } from 'common/IconLoader';

const toggleStatuses = {
  LEFT_PENDING: 'left_pending',
  LEFTED: 'lefted',
  LEFT_FAILED: 'left_failed',
  RIGHT_PENDING: 'right_pending',
  RIGHTED: 'righted',
  RIGHT_FAILED: 'right_failed'
};

class Toggle extends Component {
  state = {
    toggleStatus: null,
    hasFirstRenderedWithDevice: false,
    lockError: null,
    isToggleUsed: false
  };

  doLeftToggle() {
    this.setState({ toggleStatus: toggleStatuses.LEFT_PENDING, showCheck: false, startMode: null, isToggleUsed: true });
    this.props.dispatch(
      this.props.leftToggleFunction(
        ...this.props.leftToggleFunctionParameters,
        (result) => {
          this.setState({ toggleStatus: toggleStatuses.LEFTED });
          this.props.hasCheck && this.setState({ showCheck: true });
        },
        (error) => {
          // this.setState({toggleStatus: toggleStatuses.LEFT_FAILED, lockError: error.message ? error.message : JSON.stringify(error)});
          this.setState({ toggleStatus: toggleStatuses.LEFT_FAILED });

          let errorText = error && error.message ? error.message : JSON.stringify(error);
          this.props.onError(errorText ? errorText : 'Unknown error');
        }
      )
    );
  }

  doRightToggle() {
    this.setState({
      toggleStatus: toggleStatuses.RIGHT_PENDING,
      showCheck: false,
      startMode: null,
      isToggleUsed: true
    });
    this.props.dispatch(
      this.props.rightToggleFunction(
        ...this.props.rightToggleFunctionParameters,
        (result) => {
          this.setState({ toggleStatus: toggleStatuses.RIGHTED });
          this.props.hasCheck && this.setState({ showCheck: true });
        },
        (error) => {
          this.setState({ toggleStatus: toggleStatuses.RIGHT_FAILED });

          let errorText = error && error.message ? error.message : JSON.stringify(error);
          this.props.onError(errorText ? errorText : 'Unknown error');
        }
      )
    );
  }

  isToggleDisabled() {
    let isDisabled = false;

    switch (this.props.mode) {
      case 'lockUnlock':
        if (this.props.device != null) {
          if (this.props.device.connectionState === 'Connected') isDisabled = false;
          if (this.props.device.connectionState === 'Disconnected') isDisabled = true;
          if (!this.props.rightPermissions && this.state.toggleStatus === toggleStatuses.RIGHTED) isDisabled = true;
          if (!this.props.leftPermissions && this.state.toggleStatus === toggleStatuses.LEFTED) isDisabled = true;
        }
        break;
      default:
        isDisabled = false;
    }

    return isDisabled;
  }

  componentDidUpdate(prevProps) {
    //device is null on componentDidMount, this section waits for a when device to be read in before initalizing the starting lockedStates
    if (!this.state.hasFirstRenderedWithDevice && this.props.device && this.props.hasDeviceParameter) {
      //simy this.props.device.parameters && this.props.device.parameters.adminState)
      if (this.props.isReportedLeft) {
        this.setState({ toggleStatus: toggleStatuses.LEFTED });
        this.setState({ startMode: toggleStatuses.LEFTED });
      }

      if (this.props.isReportedRight) {
        this.setState({ toggleStatus: toggleStatuses.RIGHTED });
        this.setState({ startMode: toggleStatuses.RIGHTED });
      }

      this.setState({ hasFirstRenderedWithDevice: true });
    }

    if (
      this.props.targetDeviceValue &&
      prevProps.targetDeviceValue &&
      (prevProps.targetDeviceValue !== this.props.targetDeviceValue || this.state.errorReset)
    ) {
      this.setState({ startMode: null });
      if (
        this.props.leftDeviceValues.includes(this.props.targetDeviceValue) &&
        this.state.toggleStatus !== toggleStatuses.LEFTED &&
        this.state.toggleStatus !== toggleStatuses.LEFT_PENDING &&
        this.state.toggleStatus !== toggleStatuses.RIGHT_PENDING
      )
        this.setState({ toggleStatus: toggleStatuses.LEFTED, errorReset: false });

      if (
        !this.props.leftDeviceValues.includes(this.props.targetDeviceValue) &&
        this.state.toggleStatus !== toggleStatuses.RIGHTED &&
        this.state.toggleStatus !== toggleStatuses.LEFT_PENDING &&
        this.state.toggleStatus !== toggleStatuses.RIGHT_PENDING
      )
        this.setState({ toggleStatus: toggleStatuses.RIGHTED, errorReset: false });
    }

    if (this.state.showCheck) {
      this.hideCheckTimeout = setTimeout(() => {
        this.setState(() => ({ showCheck: false }));
      }, 1500);
    }
  }

  componentWillUnmount() {
    if (this.hideCheckTimeout != null) {
      clearTimeout(this.hideCheckTimeout);
    }
  }

  render() {
    let leftToggleModal = null;
    let rightToggleModal = null;

    if (this.props.hasModal)
      switch (this.props.mode) {
        case 'lockUnlock':
          leftToggleModal = (
            <div className="lockModal">
              <Modal
                role="alertdialog"
                aria-labelledby="lock_modal_title"
                closeTargetRef={null}
                close={() => {
                  this.setState({ isLeftModalOpen: false });
                }}
                animate={false}
                animateX={false}
                opaque={true}
                height={210}
              >
                <div className="SingleDevicePage_LockModal">
                  <div id="lock_modal_title" className="SingleDevicePage_LockModal_Header_Div">
                    <img alt="" className="lockModalIcon" src={this.props.iconLeft}></img>
                    <span style={{ fontWeight: 400, color: '#C60000', marginRight: '4px' }}>Lock</span> this device?
                  </div>
                  <div className="SingleDevicePage_UnlockModal_Description_Div">
                    <span>5G Service will be interrupted</span>
                  </div>
                  <div className="SingleDevicePage_LockModal_Buttons">
                    <button
                      className="Global_RoundedButton SingleDevicePage_LockModal_CancelButton"
                      onClick={() => {
                        this.setState({ isLeftModalOpen: false });
                      }}
                    >
                      Cancel, keep it <span style={{ fontWeight: 400 }}>unlocked</span>
                    </button>
                    <button
                      className="Global_RoundedButton SingleDevicePage_LockModal_ConfirmButton"
                      onClick={() => {
                        this.setState({ isLeftModalOpen: false });
                        this.state.toggleStatus === toggleStatuses.RIGHTED && this.doLeftToggle();
                      }}
                    >
                      Yes, <span style={{ fontWeight: 400 }}>lock</span> this device
                    </button>
                  </div>
                </div>
              </Modal>
            </div>
          );

          rightToggleModal = (
            <div className="unlockModal">
              <Modal
                role="alertdialog"
                aria-labelledby="unlock_modal_title"
                closeTargetRef={null}
                close={() => {
                  this.setState({ isRightModalOpen: false });
                }}
                animate={false}
                animateX={false}
                opaque={true}
                height={210}
              >
                <div className="SingleDevicePage_UnlockModal">
                  <div id="unlock_modal_title" className="SingleDevicePage_UnlockModal_Header_Div">
                    <img alt="" className="unlockModalIcon" src={this.props.iconRight}></img>
                    <span style={{ fontWeight: 400, color: '#005082', marginRight: '4px' }}>Unlock</span> this device?
                  </div>
                  <div className="SingleDevicePage_UnlockModal_Buttons">
                    <button
                      className="Global_RoundedButton SingleDevicePage_UnlockModal_CancelButton"
                      onClick={() => {
                        this.setState({ isRightModalOpen: false });
                      }}
                    >
                      Cancel, keep it <span style={{ fontWeight: 400 }}>locked</span>
                    </button>
                    <button
                      className="Global_RoundedButton SingleDevicePage_UnlockModal_ConfirmButton"
                      onClick={() => {
                        this.setState({ isRightModalOpen: false });
                        this.state.toggleStatus === toggleStatuses.LEFTED && this.doRightToggle();
                      }}
                    >
                      Yes, <span style={{ fontWeight: 400 }}>unlock</span> this device
                    </button>
                  </div>
                </div>
              </Modal>
            </div>
          );
          break;
        default:
          break;
      }

    let leftToggleActiveModal = null;
    //if(this.state.lockModalOpen)
    if (this.props.hasModal && this.state.isLeftModalOpen) {
      leftToggleActiveModal = leftToggleModal;
    }

    let rightToggleActiveModal = null;
    //if(this.state.isRightModalOpen)
    if (this.props.hasModal && this.state.isRightModalOpen) {
      rightToggleActiveModal = rightToggleModal;
    }
    //console.log("isToggleDisabled:", this.isToggleDisabled(), "hasDeviceParameter:", "props:", this.props, "state:", this.state)

    return (
      <div>
        {this.isToggleDisabled() && this.props.hasDeviceParameter && (
          <div aria-label={this.props['aria-label']} className="toggleSection">
            <div role="button" aria-disabled={true} className="deviceLockToggle">
              <img alt="" src={IconLoader.icon_slider_bg} />
              <img
                alt=""
                className={classnames({
                  startLeftToggle: this.state.toggleStatus === toggleStatuses.LEFTED,
                  startRightToggle: this.state.toggleStatus === toggleStatuses.RIGHTED
                })}
                src={
                  this.state.toggleStatus === toggleStatuses.LEFTED
                    ? this.props.iconLeftDisabled
                    : this.state.toggleStatus === toggleStatuses.RIGHTED
                    ? this.props.iconRightDisabled
                    : null
                }
              />
            </div>
            {this.state.toggleStatus === toggleStatuses.LEFTED && (
              <span className="lockedTextDisabled">{this.props.leftedText}</span>
            )}
            {this.state.toggleStatus === toggleStatuses.RIGHTED && (
              <span className="unlockedTextDisabled">{this.props.rightedText}</span>
            )}
          </div>
        )}
        {!this.props.hasError && !this.isToggleDisabled() && this.props.hasDeviceParameter && (
          <div aria-label={this.props['aria-label']} className="toggleSection">
            {this.props.hasModal && (
              <div>
                {leftToggleActiveModal}
                {rightToggleActiveModal}
              </div>
            )}

            <div
              role="button"
              className="deviceLockToggle"
              onClick={() => {
                if (this.props.hasModal) {
                  this.state.toggleStatus === toggleStatuses.LEFTED && this.setState({ isRightModalOpen: true });
                  this.state.toggleStatus === toggleStatuses.RIGHTED && this.setState({ isLeftModalOpen: true });
                } else {
                  this.state.toggleStatus === toggleStatuses.LEFTED && this.doRightToggle();
                  this.state.toggleStatus === toggleStatuses.RIGHTED && this.doLeftToggle();
                }
              }}
            >
              <img alt="" src={IconLoader.icon_slider_bg} />
              <img
                alt=""
                className={classnames({
                  startLeftToggle: this.state.startMode === toggleStatuses.LEFTED,
                  startRightToggle: this.state.startMode === toggleStatuses.RIGHTED,
                  leftToggle:
                    this.state.isToggleUsed &&
                    (this.state.toggleStatus === toggleStatuses.LEFTED ||
                      this.state.toggleStatus === toggleStatuses.LEFT_PENDING),
                  rightToggle:
                    this.state.isToggleUsed &&
                    (this.state.toggleStatus === toggleStatuses.RIGHTED ||
                      this.state.toggleStatus === toggleStatuses.RIGHT_PENDING)
                })}
                src={
                  this.state.toggleStatus === toggleStatuses.LEFTED
                    ? this.props.iconLeft
                    : this.state.toggleStatus === toggleStatuses.RIGHT_PENDING
                    ? this.props.iconRightPending
                    : this.state.toggleStatus === toggleStatuses.RIGHTED
                    ? this.props.iconRight
                    : this.state.toggleStatus === toggleStatuses.LEFT_PENDING
                    ? this.props.iconLeftPending
                    : null
                }
              />
            </div>

            {this.state.toggleStatus === toggleStatuses.LEFTED && (
              <span className={classnames('toggleText', { lockedText: this.props.mode === 'lockUnlock' })}>
                {this.props.leftedText}
              </span>
            )}
            {this.state.toggleStatus === toggleStatuses.RIGHT_PENDING && (
              <span className={classnames('toggleText', { unlockingText: this.props.mode === 'lockUnlock' })}>
                {this.props.rightedTextPending}
              </span>
            )}
            {this.state.toggleStatus === toggleStatuses.RIGHTED && (
              <span className={classnames('toggleText', { unlockedText: this.props.mode === 'lockUnlock' })}>
                {this.props.rightedText}
              </span>
            )}
            {this.state.toggleStatus === toggleStatuses.LEFT_PENDING && (
              <span className={classnames('toggleText', { lockingText: this.props.mode === 'lockUnlock' })}>
                {this.props.leftedTextPending}
              </span>
            )}

            {this.state.isToggleUsed && this.state.showCheck && (
              <img
                alt=""
                className={classnames({ defaultToggleCheck: true, defaultCheckmarkAnimation: this.state.showCheck })}
                src={IconLoader.icon_check_green}
              />
            )}

            {(this.state.toggleStatus === toggleStatuses.RIGHT_PENDING ||
              this.state.toggleStatus === toggleStatuses.LEFT_PENDING) && (
              <div className="dotLoader">
                <div></div>
                <div></div>
                <div></div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default connect((store) => {
  return {};
})(Toggle);
